export function toMin2digits(number) {
  if (!number) return "00"
  if (number.toString().length === 1) return "0" + number
  return number
}
